import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { ProjectId, StatusUpdateId } from 'api/models';
import { Loading } from 'components/atoms/loading';
import { DocumentProvider } from 'components/organisms/document/document-store';
import { FetchStatus } from 'data/core';
import {
  selectActiveStatusUpdate,
  setActiveStatusUpdate,
} from 'data/status-updates';
import { saveTasks } from 'data/tasks/slice';
import { useGetStatusUpdateDetailsQuery } from 'queries/status-updates';
import { useProjectTasksQuery } from 'queries/task';
import { logger } from 'services';
import { RespStatusUpdateContent } from './resp-status-update';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RespStatusUpdate: React.FC = () => {
  const { projectId: _projectId, statusUpdateId: _statusUpdateId } =
    useParams<{ projectId: string; statusUpdateId: string }>();

  const projectId = Number(_projectId);
  const statusUpdateId = Number(_statusUpdateId);

  const { data } = useGetStatusUpdateDetailsQuery(
    StatusUpdateId(statusUpdateId),
  );
  const dispatch = useDispatch();
  const activeStatusUpdate = useSelector(selectActiveStatusUpdate);

  useEffect(() => {
    if (data !== undefined && activeStatusUpdate === null) {
      dispatch(setActiveStatusUpdate(data));
    }
  }, [data, dispatch, activeStatusUpdate]);

  useProjectTasksQuery(ProjectId(projectId), {
    retry: 1,
    refetchOnMount: true,
    staleTime: 0,
    onSuccess: async (tasks) => {
      try {
        dispatch(saveTasks({ data: tasks, fetchStatus: FetchStatus.Loaded }));
      } catch (error) {
        logger.error('failed to fetch tasks', { error });
      }
    },
  });

  if (activeStatusUpdate === null) {
    return (
      <Wrapper>
        <Loading />
      </Wrapper>
    );
  }

  return (
    <DocumentProvider>
      <RespStatusUpdateContent />
    </DocumentProvider>
  );
};
